import { Flame } from "lucide-react";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2 select-none ${className}`} data-testid="sx-logo">
    <span className="font-display text-2xl font-extrabold tracking-tighter leading-none">
      S<span className="relative">X</span>
    </span>
    <span className="relative -ml-1 -mt-3">
      <Flame className="h-5 w-5 flame-text" fill="url(#flame)" strokeWidth={2.2} />
    </span>
    <span className="ml-1 flex flex-col leading-none">
      <span className="font-display text-sm font-bold tracking-[0.35em] flame-text">HEATING</span>
      <span className="font-mono-sx text-[9px] tracking-[0.4em] text-zinc-500">LTD</span>
    </span>
    <svg width="0" height="0" className="absolute">
      <defs>
        <linearGradient id="flame" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ff3800" />
          <stop offset="55%" stopColor="#f5641e" />
          <stop offset="100%" stopColor="#ffb800" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);
